import { httpsCallable } from 'firebase/functions'
import { functions } from '../firebase-config'

export async function fetchDictamen(contextoEnriquecido, userRef) {
  const callGenerar = httpsCallable(functions, 'generarDictamen')
  const resp = await callGenerar({ contextoEnriquecido, userRef })
  const data = resp?.data || {}
  if (!data.ok) throw new Error('No se pudo generar dictamen')
  return {
    text: data.dictamen || '',
    verificationCode: data.verificationCode || '',
  }
}
